<template>
  <tg-layout>
    <template slot="header">
        <el-row type="flex" justify="space-between">
            <tg-search-tool @on-submit="handleSearch">
                <tg-button
                    v-if="!isSub"
                    round
                    border
                    hoverBorderOnly
                    theme="primary"
                    @click.native="handleAdd"
                >
                    <template slot="icon" slot-scope="scope">
                    <i
                        class="tg-icon tg-icon-export-p"
                        :class="{ active: scope.isHover }"
                    ></i>
                    </template>
                    {{ $t("component.btn.add") }}
                </tg-button>
                <el-input
                    :placeholder="$t('component.form.input.placeholder.agent')"
                    v-model="searchData.target_name"
                    class="tg-input input-search-username"
                    size="small"
                    clearable
                ></el-input>
            </tg-search-tool>
        </el-row>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
    >
    <template slot="group" slot-scope="scope">
      <span >
        {{ $t("column.l" + scope.value + "") }}
      </span>
    </template>
    <template slot="enable_status" slot-scope="scope">
      <span v-if="scope.value == '1'">
        {{ $t("enum.blocked[0]") /* 開啟 */ }}
      </span>
      <span v-if="scope.value == '0'">
        {{ $t("enum.blocked[1]") /* 關閉 */ }}
      </span>
    </template>
    <template slot="edit" slot-scope="scope">
      <tg-button @click.native="handleEditClick(scope.row)" style="font-size:18px; color: #fff; background-color: #7367f0;">{{ $t("component.btn.edit") /* 編輯 */ }}</tg-button>
      <tg-button @click.native="handleDeleteClick(scope.row)" style="margin-left: 10px; font-size:18px; color: #fff; background-color: #ea5455;">{{ $t("component.btn.delete") /* 編輯 */ }}</tg-button>
    </template>
    </tg-table>

    <tg-dialog
        ref="detail"
        :show-close="true"
        theme="info"
        :showIcon="false"
        width="70%"
        :title="detail.title"
        :visible.sync="detail.visible"
        destroy-on-close
        :showFooter="true"
        append-to-body
        custom-class="tg-confirm-dialog"
        @on-confirm="handleAction(detailData)"
        :confirmLabel="$t('component.btn.save')"
    >
        <tg-form-table
            :columns="detailColumns"
            :data.sync="detailData"
            :fenceRow="2"
            :fenceCol="2"
            :columnWidth="250"
            :cellWidth="400"
        >

            <template slot="editable" slot-scope="scope">
                <template
                    v-if="!isSub && ('editable' in scope.column && scope.column.editable == true) "
                >
                    <tg-dropdown
                        v-if="scope.column.dropdown && scope.column.dropdown == true"
                        :items="dropdown"
                        :select="detailData[scope.column.name]"
                        trigger="click"
                        @on-change="handleBlockedChange($event, scope.column.name)"
                    ></tg-dropdown>
                    <el-input
                        v-else
                        v-model="detailData[scope.column.name]"
                        class="tg-input col-8"
                        clearable
                    ></el-input>
                </template>
               
                <template v-else>
                    <span>
                        <span >{{ scope.row[scope.column.name] }}</span>
                    </span>
                </template>
            </template>
        </tg-form-table>
    </tg-dialog>

    <tg-dialog
        ref="dialog"
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        :visible.sync="deleteDialog.visible"
        :show-close="true"
        :subject="deleteData.agent_username+'-'+deleteData.allow_ip"
        :subtitle="this.$t('page.ip_white.action.delete') /* 确定删除吗?*/"
        theme="warning"
        showCancelBtn
        destroy-on-close
        append-to-body
        width="20%"
        @on-confirm="handleAction(deleteData)"
    ></tg-dialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTable from "@/components/table/TgTable";
import TgButton from "@/components/button/TgButton";
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgSearchTool from "@/components/tool/TgSearchTool";

import apis from "@/apis";

const api = apis.ip_white;

export default {
  components: {
    TgLayout,
    TgTable,
    TgButton,
    TgDialog,
    TgFormTable,
    TgDropdown,
    TgSearchTool
  },
  data() {
    return {
        columns: [],
        detailColumns: [],
        proxy: api.getData,
        searchData:{
            target_name:"",
        },
        detailData: {},
        deleteData:{},
        detail: {
            title: "",
            visible: false,
        },
        deleteDialog: {
            title: "",
            visible: false,
        },
        dropdown: [{
            label:this.$t('enum.blocked[0]') /* 開啟 */,
            value:1
        },{
            label:this.$t('enum.blocked[1]') /* 關閉 */,
            value:0
        }],
    };
  },
  created() {
    api.getColumns().then((response) => {
        this.columns = response.data;

        // 避免影響this.columns，如果直接filter this.columns 會導致this.columns的slot也被變更為editable
        let obj = JSON.parse(JSON.stringify(response.data));
        this.detailColumns = obj.filter(x => {
            if (x.editable == true) {
                x.slot = "editable";
            }
            return x.isDetail == true;
        })
        this.$refs.table.init();
    });
  },
    methods: {
        handleSearch() {
            this.$refs.table.search(this.searchData);
        },
        handleAdd() {
            // 避免影響this.columns，如果直接filter this.columns 會導致this.columns的slot也被變更為editable
            let obj = JSON.parse(JSON.stringify(this.columns));
            // 如果操作帳號本身是代理帳號，則新增時帳號直接帶入本身帳號
            this.detail.title = this.$t("component.btn.add");
            this.detailData = {};
            this.detailData.action = "add";

            if(this.$user.group == 20){
                this.detailColumns = obj.filter(x => {
                    if (x.editable == true) {
                        x.slot = "editable";
                    }
                    return x.isDetail == true;
                })
                this.detailData.agent_username = this.$user.username;
            }else{
                this.detailColumns = obj.filter(x => {
                    x.slot = "editable";
                    x.editable = true;
                    return x.isDetail == true;
                })
            }

            this.detail.visible = true;
        },
        handleEditClick(row) {
            // 避免影響this.columns，如果直接filter this.columns 會導致this.columns的slot也被變更為editable
            let obj = JSON.parse(JSON.stringify(this.columns));

            this.detail.title = row.agent_username+"-"+ row.allow_ip
            this.detailData = JSON.parse(JSON.stringify(row));
            this.detailData.action = "edit";
            this.detailData.origin_allow_ip = row.allow_ip;

            this.detailColumns = obj.filter(x => {
                if (x.editable == true) {
                    x.slot = "editable";
                }
                return x.isDetail == true;
            })

            this.detail.visible = true;
        },
        handleDeleteClick(row) {
            // 避免影響this.columns，如果直接filter this.columns 會導致this.columns的slot也被變更為editable
            this.deleteData = JSON.parse(JSON.stringify(row));
            this.deleteData.action = "delete";
            this.deleteDialog.visible = true;
        },
        handleAction(data) {
            this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', true);
            api.action({ ...data }).then((response) => {
                this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
                if (response.retcode == 0) {
                    this.$message.success(this.$t("message.success.update"));
                    this.detail.visible = false;
                    this.$refs.table.init();
                } else {
                    this.$message.error(this.$t("statusCode[" + response.retcode + "]"));
                }

                this.$store.commit('TOGGLE_FULL_SCREEN_LOADING', false);
            });
        },
        handleBlockedChange(item, columnName) {
            this.detailData[columnName] = item.value;
        },
    },
};
</script>